export const INVOICE_SETTLEMENT_TAG = 'invoice_settlement';
export const CASH_BACK_TAG = 'cash_back';
export const TRANSFER_TAG = 'transfer';

export const CREDIT_WALLET_TAGS = ['advance', 'deposit'] as const;
export const DEBIT_WALLET_TAGS = [CASH_BACK_TAG] as const;
export const RESERVED_WALLET_TAGS = [INVOICE_SETTLEMENT_TAG] as const;
export const SYSTEM_WALLET_TAGS = [
  'advance',
  'deposit',
  TRANSFER_TAG,
  CASH_BACK_TAG,
  INVOICE_SETTLEMENT_TAG,
] as const;
export const MANUAL_SYSTEM_WALLET_TAGS = [
  'advance',
  'deposit',
  CASH_BACK_TAG,
  TRANSFER_TAG,
] as const;

export const isTransferTag = (tag: string) => tag.trim().toLowerCase() === TRANSFER_TAG;
export const isReservedWalletTag = (tag: string) =>
  (RESERVED_WALLET_TAGS as readonly string[]).includes(tag.trim().toLowerCase());

export const pairedTypeForTag = (tag: string): WalletRecordType | null => {
  const key = tag.trim().toLowerCase();
  if ((CREDIT_WALLET_TAGS as readonly string[]).includes(key)) return 'CREDIT';
  if ((DEBIT_WALLET_TAGS as readonly string[]).includes(key)) return 'DEBIT';
  return null;
};

/** Every credit to the wallet gets a receipt, except the system invoice settlement. */
export const isReceiptableWalletRecord = (row: { type: string; tag: string }) =>
  String(row.type).toUpperCase() === 'CREDIT'
  && String(row.tag || '').trim().toLowerCase() !== INVOICE_SETTLEMENT_TAG;

export const defaultTagForType = (type: WalletRecordType): string =>
  type === 'DEBIT' ? CASH_BACK_TAG : 'advance';

export type WalletRecordType = 'CREDIT' | 'DEBIT';

export type WalletPostPreset = {
  tag?: string;
  mode?: WalletRecordType | 'TRANSFER';
  ref?: string;
  amount?: number;
  description?: string;
  lockTag?: boolean;
  lockMode?: boolean;
};

export type ClientWalletRow = {
  client_id: number;
  client: string;
  balance: number;
  is_active: boolean;
  created?: string;
  updated?: string;
};

export type WalletRecordRow = {
  id: number;
  date: string;
  type: WalletRecordType;
  amount: number;
  tag: string;
  mode?: number | null;
  mode_name?: string | null;
  description?: string | null;
  client: number;
  client_name: string;
  source_client?: number | null;
  source_client_name?: string | null;
  ref: string;
  user?: string;
  created?: string;
  updated?: string;
};

export type WalletTagOption = {
  tag: string;
  count: number;
};

export const walletSignedAmount = (row: Pick<WalletRecordRow, 'type' | 'amount'>): number => {
  const amount = Number(row.amount || 0);
  return String(row.type).toUpperCase() === 'DEBIT' ? -amount : amount;
};
